module.exports = __webpack_public_path__ + "img/block-v-2.106d8775.gif";